var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 0H4.66672C3.52172 0 2.59338 0.646667 2.59338 1.44333H12.4017C12.4017 0.651667 11.4734 0 10.3334 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6667 4.56055H1.33333C0.979711 4.56055 0.640573 4.70102 0.390524 4.95107C0.140476 5.20112 0 5.54026 0 5.89388V13.6672C0 14.0208 0.140476 14.36 0.390524 14.61C0.640573 14.8601 0.979711 15.0005 1.33333 15.0005H13.6667C14.0203 15.0005 14.3594 14.8601 14.6095 14.61C14.8595 14.36 15 14.0208 15 13.6672V5.89055C14.9991 5.5375 14.8583 5.19922 14.6083 4.94989C14.3583 4.70056 14.0197 4.56055 13.6667 4.56055ZM9.86667 10.1089L7.66667 11.5372L5.55833 12.9005C5.49887 12.9392 5.43003 12.9609 5.35917 12.9635C5.2883 12.9661 5.21807 12.9494 5.15596 12.9151C5.09386 12.8809 5.0422 12.8305 5.00652 12.7692C4.97083 12.7079 4.95245 12.6381 4.95333 12.5672V6.98888C4.95245 6.91798 4.97083 6.84816 5.00652 6.78688C5.0422 6.72561 5.09386 6.67517 5.15596 6.64095C5.21807 6.60673 5.2883 6.59002 5.35917 6.59259C5.43003 6.59516 5.49887 6.61692 5.55833 6.65555L7.66667 8.02388L9.86667 9.45221C9.92135 9.48778 9.96629 9.53644 9.99739 9.59378C10.0285 9.65112 10.0448 9.71531 10.0448 9.78055C10.0448 9.84578 10.0285 9.90998 9.99739 9.96732C9.96629 10.0247 9.92135 10.0733 9.86667 10.1089Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6267 2.28223H3.37338C2.22838 2.28223 1.30005 2.92889 1.30005 3.72556H13.7C13.7 2.92889 12.7717 2.28223 11.6267 2.28223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubPlan);
export default __webpack_public_path__ + "static/media/sub-plan.5d3af2c80fabb2a4fe8b75a7142db72e.svg";
export { ForwardRef as ReactComponent };